import { ForawrdBackwardButton } from "../../../styled-components/PageHeaderStyles";
import LabelText from "../../../ui/LabelText";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "styled-components";
import { useSearch } from "../../../contexts/PlayerSearchContext";
import LabelNumber from "../../../styled-components/LabelNumber";
import { useLoading } from "../../../contexts/LoadingContext";
import { IValueGraph, IValueSeasonGraphChart } from "../../../types/IValueGraphChart";
import SecondaryButton from "../../../ui/SecondaryButton";
import { useState } from "react";
import { IFinancialPlayerTransfer } from "../../../types/IClubDetail";
import SimulationPlayersTable from './SimulationPlayersTable'
import { IPlayerComparisonData, SortableKeys } from "../../../types/IPlayerComparison";





const ValueGraphContainer = styled.div`
//   border: 1px solid ${({ theme }) => theme.playerDataBorder};
padding: 0px 68px 0px 68px;
`;
const HeaderContainer = styled.div`
  background: ${({ theme }) => theme.playerCardBackground};
`;
const ValueGraphFullView = styled.div`
  background: ${({ theme }) => theme.playerContentBackground};
`;

const options = ['Matches', 'Seasons'];

interface FullViewContentProps {
    tableData: IPlayerComparisonData[];
    sortKey: SortableKeys;
    setSortKey: React.Dispatch<React.SetStateAction<SortableKeys>>;
    isFormSortList?: boolean;
    benchmarkID?: number;
    isFromSimulation?: boolean;
    onClose: () => void;
    isFullView: boolean;
}

const FullViewSimulationPlayersTable: React.FC<FullViewContentProps> = ({tableData,  sortKey, setSortKey , isFormSortList, benchmarkID, isFromSimulation, onClose , isFullView }) => {

  return (
    <div>
      <HeaderContainer className="header-container">
        <div className="player-name">
          <LabelText className="drawer-title expanded-market-value">Current Squad</LabelText>
          {/* <LabelNumber className="market-value-player-name">: {clubName!}</LabelNumber> */}
        </div>
        <div className="market-value-buttons">
        </div>
        <div className="player-name-cross">
          <ForawrdBackwardButton onClick={onClose}>
            <CloseIcon className="cta-btn-icons" />
          </ForawrdBackwardButton>
        </div>
      </HeaderContainer>
      <ValueGraphFullView className="valuegraph-fullview">
        <ValueGraphContainer className={`value-graph-container ${isFullView && "fullview-container"}`}>

        <SimulationPlayersTable
                      sortKey={sortKey}
                      setSortKey={setSortKey}
                      tableData={tableData!}
                      isFormSortList={false}
                      benchmarkID={0}
                      isFromSimulation={true}
                      isFullView={isFullView}
                    />
         
        </ValueGraphContainer>
      </ValueGraphFullView>
    </div>
  );
};

export default FullViewSimulationPlayersTable;
